import ButtonMultiClick from "@/components/Buttons/ButtonMultiClick";
import { useDeviceInfoQuery } from "@/hooks";
import config from "@/lib/config";
import maybeIOS from "@/lib/maybeIOS";
import { useCallback } from "react";

export default function OpenApp({ watch }) {
  const { data: { deviceInfo } = {} } = useDeviceInfoQuery({
    fetchPolicy: "cache-first",
  });
  const { isAndroid } = deviceInfo ?? {};
  const isIOS = maybeIOS(deviceInfo);
  const mobileAppLinkVOD = `spooxnew://works/${watch.episode.id}`;

  const openApp = useCallback(() => {
    if (isIOS) {
      window.location.href = mobileAppLinkVOD;
    } else if (isAndroid) {
      window.location.href = `intent://works/${watch.episode.id}#Intent;scheme=spooxnew;package=${config.androidNewPackageName};end`;
    }
  }, [isAndroid, isIOS, watch, mobileAppLinkVOD]);

  return (
    <div>
      <ButtonMultiClick fillColor large onClick={openApp}>
        アプリで視聴する
      </ButtonMultiClick>
      {isIOS && (
        <div>
          スカパー！動画ストアアプリのインストールがまだの方はアプリストアよりインストールをお願いします。
        </div>
      )}
      {isAndroid && (
        <div>
          スカパー！動画ストアアプリのインストールがまだの方はアプリストアよりインストールをお願いします。
        </div>
      )}
    </div>
  );
}
